import { expandSchedule } from './positions';

// Aritmética de la reconciliación del importador de programación.
//
// La regla de docs/CARGA_PROGRAMACION.md §0: una carga solo vale si dos caminos
// independientes llegan al mismo número. Por eso estas funciones NO cuentan los "1" de la
// grilla (eso ya lo hizo el lector del Excel): expanden el horario **igual que lo hará la
// carga real** con `expandSchedule`, para que lo que muestra la pantalla sea lo que van a
// ser las posiciones en la base de datos. Si el usuario recorta las fechas o pide 2
// recursos por día, el número cambia aquí y la reconciliación se rompe a la vista.

/** Horario de mentira: a `expandSchedule` solo le importan los días, el rango y los recursos. */
const SIN_IDS = { scheduleId: '', campaignId: '', pdvId: '' };

/**
 * Jornadas que generará una tienda. `weekdays` en null es el patrón que no se pudo traducir
 * a días de semana (calendario estratégico): no se puede representar como horario, así que
 * no aporta jornadas y el descuadre lo delata.
 */
export function jornadasPrevistas(
  weekdays: number[] | null,
  recursos: number,
  inicio: string,
  fin: string,
): number {
  if (weekdays === null || weekdays.length === 0 || recursos < 1) return 0;
  return expandSchedule(
    { ...SIN_IDS, weekdays, extraDates: [], vigenteDesde: null, vigenteHasta: null, startTime: '00:00', endTime: '23:59', headcount: recursos, rateAmount: 1, rateUnit: 'jornada' },
    inicio,
    fin,
  ).length;
}

export interface ReconciliacionBloque {
  /** Tiendas incluidas en la carga (las excluidas no cuentan y por eso descuadran). */
  tiendas: number;
  /** Jornadas que va a generar el sistema. */
  jornadas: number;
  /** TOTAL DÍAS CAPTADOR del bloque, tal como lo declara el Excel. */
  declaradas: number | null;
  cuadra: boolean;
  /** jornadas − declaradas; null si el Excel no declara el total (no es verificable). */
  diferencia: number | null;
  /** Días por tienda cuando todas coinciden, para poder decir "8 tiendas × 27 días". */
  diasPorTienda: number | null;
}

/** Compara lo que se va a generar contra lo que declara el Excel, para un bloque de tarifa. */
export function reconciliarBloque(
  tiendas: (number[] | null)[],
  recursos: number,
  inicio: string,
  fin: string,
  declaradas: number | null,
): ReconciliacionBloque {
  const porTienda = tiendas.map((w) => jornadasPrevistas(w, recursos, inicio, fin));
  const jornadas = porTienda.reduce((suma, j) => suma + j, 0);
  const primera = porTienda[0];
  const parejas = porTienda.length > 0 && porTienda.every((j) => j === primera);
  return {
    tiendas: tiendas.length,
    jornadas,
    declaradas,
    cuadra: declaradas !== null && jornadas === declaradas,
    diferencia: declaradas === null ? null : jornadas - declaradas,
    diasPorTienda: parejas && recursos > 0 ? primera / recursos : null,
  };
}
